import React from "react";

const BanksList = ({ banks }) => {
	return (
		<div>
			{banks
				.filter((bank) => !bank.hidden)
				.map(({ name, accountNumber, accountType }) => (
					<p key={name} className="mb-0">
						<span className="text-info">*</span> {name} cuenta {accountType} No.{" "}
						{accountNumber}
					</p>
				))}
			<p key="qr" className="mb-0">
				<span className="text-info">*</span> Código QR Bancolombia cuenta
				Ahorros No. *1863
			</p>
		</div>
	);
};

export default BanksList;
